/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetContactRequestJobDetailQueryResponse,
  GetContactRequestJobDetailPathParams,
} from '../types/GetContactRequestJobDetail'

function getGetContactRequestJobDetailUrl({
  id,
}: {
  id: GetContactRequestJobDetailPathParams['id']
}) {
  const res = { method: 'GET', url: `/api/v1/contact_request/${id}/` as const }
  return res
}

/**
 * @summary Get a single contact request job's detail
 * {@link /api/v1/contact_request/:id/}
 */
export async function getContactRequestJobDetail(
  { id }: { id: GetContactRequestJobDetailPathParams['id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetContactRequestJobDetailQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getGetContactRequestJobDetailUrl({ id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
